<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>管家账号</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="手机号">
                    <el-input v-model="listQuery.tel" maxlength="11" style="width:150px" placeholder="请输入" clearable></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="el-icon-plus" plan @click="addUserData">添加管家账号</el-button>
                </el-form-item>

            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <el-table-column prop="tel" label="电话" width="150"></el-table-column>
                <el-table-column prop="userName" label="姓名" width="80"></el-table-column>
                <el-table-column prop="userId" label="关联账号id"></el-table-column>
                <el-table-column label="状态" fixed="right" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.unbind==0">启用</span>
                        <span v-else>停用</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lastLoginTime" :formatter="dateFormatA" label="最后登录时间" w></el-table-column>

                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>
                <el-table-column prop="updateTime" :formatter="dateFormatA" label="修改时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button style="color:red;" v-if="scope.row.unbind==0" type="text" icon="el-icon-edit" @click="unbindoper(scope.row,1)">停用</el-button>
                        <el-button v-if="scope.row.unbind==1" type="text" icon="el-icon-edit" @click="unbindoper(scope.row,0)">启用</el-button>

                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <el-dialog title="添加管家账号" :visible.sync="showAdd" width="600px" :close-on-click-modal="false" center>
            <center style="color:red;">用户关联的手机一定要是管家小程序手机号</center>
            <el-form>
                <el-form-item label="用户">
                    <el-select v-model="addFrom.userId" clearable placeholder="请选择" @change="chooseUser" filterable>
                        <el-option v-for="(item,index) in sysUserList" :key="index" :label="item.userName+item.mobile" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="手机号（若有误请输入）">
                    <el-input v-model="addFrom.tel" maxlength="11" style="width:200px" placeholder="请输入" clearable></el-input>
                </el-form-item>

                <el-form-item label="姓名">
                    <el-input v-model="addFrom.userName" maxlength="11" style="width:200px" placeholder="请输入" clearable></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveUserData">提交</el-button>
                <el-button @click="showAdd = false">关闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
    components: { Pagination },
    data() {
        return {
            expandedKeys: [],
            isExpand: false,
            defaultProps: {
                children: "children",
                label: "label",
            },
            sysUserList: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listData: [],
            listQuery: {
                tel: null,
            },
            addFrom: {
                userId: null,
                tel: null,
                userName: null,
            },
            showAdd: false,
        };
    },

    created() {
        this.querySearch();
    },
    methods: {
        addUserData() {
            this.getSysUser();
            this.showAdd = true;
            this.addFrom = {
                userId: null,
                tel: null,
                userName: null,
            };
        },
        unbindoper(row, bd) {
            // let mm = unbind == 0 ? "启用" : "停用";
            // mm = mm + row.tel;
            this.$confirm("是否确认"  , "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {  
                    crmApi.$axiosSysUserBrokerUnbind({
                            id: row.id,
                            unbind: bd,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("操作成功");
                                this.querySearch();
                            }
                        });
                }).catch((e) => {
                //   alert(e);
                });
        }, 
        saveUserData() {
            if (this.addFrom.userId == null || this.addFrom.userId == "") {
                this.$message.error("请选择用户");
                return;
            }
            if (this.addFrom.userName == null || this.addFrom.userName == "") {
                this.$message.error("请选择用户或修改姓名");
                return;
            }
            if (this.addFrom.tel == null || this.addFrom.tel == "") {
                this.$message.error("请选择用户或修改电话");
                return;
            }

            crmApi
                .$axiosSysUserBrokerAddUserBroker(this.addFrom)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.$message.success("操作成功");
                        this.showAdd = false;
                        this.querySearch();
                    } else {
                        this.$message.error(res.data.data);
                    }
                });
        },

        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            crmApi
                .$axiosSysUserBrokerPagePageList(this.listQuery)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.listData = res.data.data.list;
                        this.total = res.data.data.total;
                    }
                });
        },

        getSysUser() {
            service.$axiosSysUsergetallUser().then((res) => {
                if (res.data.errno == 0) {
                    this.sysUserList = res.data.data;
                }
            });
        },
        chooseUser(v) {
            let that = this;
            this.sysUserList.forEach((e) => {
                if (e.id == v) {
                    that.addFrom.userId = e.id;
                    that.addFrom.userName = e.userName;
                    that.addFrom.tel = e.mobile;
                }
            });
        },
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>